let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7jeqD")).then(() => parcelRequire('5MbuW'));